module.exports = __webpack_public_path__ + "img/7.8fe4757f.jpg";